import styles from "./guidance.module.css";

/**
 * Renders guidance.attention[]. Hidden when empty.
 *
 * @param {{
 *   attention?: Array<{
 *     id?: string,
 *     severity?: string,
 *     title?: string,
 *     detail?: string,
 *     intent?: string,
 *     href?: string | null,
 *   }>,
 *   onAttention?: (item: object) => void,
 * }} props
 */
export default function AttentionStrip({ attention = [], onAttention }) {
  const items = Array.isArray(attention) ? attention.filter((a) => a?.title) : [];
  if (!items.length) return null;

  return (
    <ul
      className={styles.attention}
      aria-label="Needs attention"
      data-testid="guidance-attention-strip"
    >
      {items.map((item) => (
        <li key={item.id || item.title}>
          {typeof onAttention === "function" ? (
            <button
              type="button"
              className={styles.attentionItem}
              data-severity={item.severity || "info"}
              data-attention-id={item.id || undefined}
              data-intent={item.intent || undefined}
              onClick={() => onAttention(item)}
            >
              <span className={styles.attentionTitle}>{item.title}</span>
              {item.detail ? (
                <span className={styles.attentionDetail}>{item.detail}</span>
              ) : null}
            </button>
          ) : (
            <div
              className={styles.attentionItem}
              data-severity={item.severity || "info"}
              data-attention-id={item.id || undefined}
              role="status"
            >
              <span className={styles.attentionTitle}>{item.title}</span>
              {item.detail ? (
                <span className={styles.attentionDetail}>{item.detail}</span>
              ) : null}
            </div>
          )}
        </li>
      ))}
    </ul>
  );
}
